// lib
import React from "react";
import PropTypes from "prop-types";
import { Button, Dialog, DialogActions, DialogContent } from "@material-ui/core";

const Alert = ({ open, onCancel, onConfirm, cancelLabel, confirmLabel, children }) => {
  return (
    <div>
      <Dialog open={open} onClose={onCancel} maxWidth="xs">
        <DialogContent>{children}</DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>{cancelLabel}</Button>
          <Button onClick={onConfirm} color="primary" autoFocus>
            {confirmLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

Alert.propTypes = {
  // parent props
  open: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  cancelLabel: PropTypes.string.isRequired,
  confirmLabel: PropTypes.string.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

Alert.defaultProps = {
  onCancel: () => null,
  onConfirm: () => null,
};

export default Alert;
